import { useIntl } from 'react-intl'

import { getHouseTypeOptions } from './house-search-filter-checkbox/house-search-filter-checkbox.utils'
import { HouseTypeEnum } from '../../../lib/graphql'

export const getSearchQueryValues = <T, K = string>(data: T | undefined) => {
  return Object.entries(data || {}).reduce<K[]>((acc, [key, value]) => {
    if (value) {
      acc.push(key as K)
    }
    return acc
  }, [])
}

export const getHouseTypeLabel = (houseType: HouseTypeEnum | null) => {
  const intl = useIntl()
  const options = getHouseTypeOptions(intl)
  const typeOption = options.find((option) => option.name === houseType)
  return typeOption ? typeOption.label : 'Type Not Found'
}
